import {
  PERMISSION_MODULE_ICON_MAP,
  PERMISSION_MODULE_LABEL_MAP,
} from '@modules/users/constants';
import { PermissionsTableRow } from '@modules/users/types';
import { TripOriginRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { PermissionResource } from 'generated/graphql';
import { startCase } from 'lodash';

export const renderPermissionModuleRowCell = (
  params: GridRenderCellParams<
    PermissionsTableRow,
    PermissionResource,
    unknown
  >,
) => {
  const module = params.value ?? '';
  const label = module ? PERMISSION_MODULE_LABEL_MAP[module] : null;
  const icon = module ? PERMISSION_MODULE_ICON_MAP[module] : null;

  return (
    <Typography
      variant="caption"
      component={Stack}
      direction="row"
      alignItems="center"
      spacing={1}
      color="text.secondary"
    >
      <Box width="35px">{icon ?? <TripOriginRounded />}</Box>
      <Typography color="text.primary" variant="body2">
        {label ?? startCase(module.toLowerCase())}
      </Typography>
    </Typography>
  );
};
